import { css } from "@emotion/css";
import { PANEL_WIDTH } from "../../constants";

// Popover mode anchors to the bottom of the panel (Meridian has no fixed positioning). No `left`:
// a fixed element keeps its in-flow horizontal position, so the popover lines up with whatever
// container ProductFeedback sits in (left-aligned in Home, centered in HIRE).
export const popoverAnchorClass = css({ position: "fixed", bottom: 0, width: PANEL_WIDTH });
